module.exports = __webpack_public_path__ + "static/media/taImg6.579992fb.png";